import { IFormMetadataProcessor } from './iFormMetaDataProcessor';
import { FormData } from '../../forms-ui-form-faas.interface';

/*
 * Execute a processing pipeline.
 * Any manipulation to the form data json should be done here prior to rendering the form.
 */
export const processFormMetadata = async (formMetadata: FormData, processors: IFormMetadataProcessor[])
	: Promise<FormData> => {
	await Promise.all(processors.map(async (processor) => {
		formMetadata = await processor.process(formMetadata);
	}));
	return formMetadata;
};
